var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proto2jsonSchema } from './protoj2jsonSchema';
export function ProtoBuffSchemaParser() {
    return {
        validate,
        parse,
        getMimeTypes,
    };
}
export default ProtoBuffSchemaParser;
function validate(input) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            proto2jsonSchema(input.data);
            // No errors found.
            return [];
        }
        catch (error) {
            let message = 'Unknown Error';
            if (error instanceof Error) {
                message = error.message;
            }
            const validateResult = [{
                    message,
                    path: input.path, // protobuff parser doesn't provide a path to the error.
                }];
            return validateResult;
        }
    });
}
function parse(input) {
    return proto2jsonSchema(input.data);
}
function getMimeTypes() {
    return [
        'application/vnd.google.protobuf;version=2',
        'application/vnd.google.protobuf;version=3',
    ];
}
